import {
  Link,
  useLocation,
} from 'react-router-dom';

import AuthPageShell from './AuthPageShell';

interface PasswordExpiredLocationState {
  email?: string;
}

export default function PasswordExpiredPage() {
  const location = useLocation();

  const state =
    location.state as
      | PasswordExpiredLocationState
      | null;

  const email = state?.email ?? '';

  return (
    <AuthPageShell title="Password update required">
      <p className="mb-6 text-center text-sm text-slate-600">
        Your password has expired. Request a reset link to continue.
      </p>

      <Link
        className="btn-primary block w-full py-3 text-center"
        to="/forgot-password"
        state={{
          email,
        }}
      >
        Reset password
      </Link>

      <Link
        className="mt-4 block text-center text-sm font-semibold text-strivre-burgundy"
        to="/login"
      >
        Return to sign in
      </Link>
    </AuthPageShell>
  );
}